<template>
    <rkm-area
        no-margin-top
        title="Jornadas"
    >
        <rkm-form ref="RkmForm">
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-date-picker
                        :end-validations="validations.periodo"
                        :range-inline="false"
                        :start-validations="validations.periodo"
                        end-label="Até"
                        range
                        start-label="Período de"
                        v-model="model.periodo"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-time-picker
                        :validations="validations.inicio"
                        label="Hora inicial"
                        v-model="model.inicio"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-time-picker
                        :validations="validations.fim"
                        label="Hora final"
                        v-model="model.fim"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-checkbox-group
                        :options="form.diasSemana"
                        :validations="validations.diasSemana"
                        button-color="outline-primary"
                        buttons
                        class="dias-semana"
                        label="Dias da semana"
                        text-field="descricao"
                        v-model="model.diasSemana"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.unidades"
                        @change="handleUnidadeChange"
                        default-option-text="Todas"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="form.infraestruturas"
                        @change="handleInfraestruturaChange"
                        default-option-text="Todos"
                        label="Local de atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="model.infraestruturaId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.ocupacoes"
                        @change="handleOcupacaoChange"
                        default-option-text="Todos"
                        label="CBO"
                        show-default-option
                        text-field="descricao"
                        v-model="model.ocupacaoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-select
                        @change="handleConectasusCidadaoChange"
                        default-option-text="Todos"
                        label="ConectaSUS Cidadão"
                        show-default-option
                        v-model="model.conectasusCidadao"
                    >
                        <rkm-form-select-option value="sim">Sim</rkm-form-select-option>
                        <rkm-form-select-option value="nao">Não</rkm-form-select-option>
                    </rkm-form-select>
                </rkm-col>

                <rkm-col cols="5" class="especialidade-col">
                    <rkm-form-select
                        :options="form.especialidades"
                        @change="handleEspecialidadeChange"
                        default-option-text="Todos"
                        label="Especialidade"
                        show-default-option
                        text-field="nome"
                        v-model="model.especialidadeId"
                        value-field="id"
                    />
                    <rkm-icon
                        icon="info"
                        color="secondary"
                        class="infor-especialidade"
                        small
                        v-rkm-popover.hover.right="{
                            html: true,
                            content: 'Se a especialidade estiver marcada como disponível no ConectaSUS Cidadão, serão exibidos campos adicionais para configurar vagas do App (consultas e retornos).'
                        }"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        :options="form.tipos"
                        @change="handleTipoChange"
                        default-option-text="Todos"
                        label="Tipo"
                        show-default-option
                        text-field="nome"
                        v-model="model.tipoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-select
                        default-option-text="Todos"
                        label="Status"
                        show-default-option
                        v-model="model.ativa"
                    >
                        <rkm-form-select-option :value="true">Ativa</rkm-form-select-option>
                        <rkm-form-select-option :value="false">Inativa</rkm-form-select-option>
                    </rkm-form-select>
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        :disabled="model.ativa"
                        :options="form.situacoes"
                        @change="handleSituacaoChange"
                        default-option-text="Todas"
                        label="Situação"
                        show-default-option
                        text-field="nome"
                        v-model="model.situacaoId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        :disabled="!!model.situacaoId"
                        :validations="validations.quantidadeConsulta"
                        label="Quantidade de consultas"
                        number
                        v-model="model.quantidadeConsulta"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        :disabled="!!model.situacaoId"
                        :validations="validations.quantidadeRetorno"
                        label="Quantidade de retornos"
                        number
                        v-model="model.quantidadeRetorno"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click="search"
                        color="primary"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="clean"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </rkm-area>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        isEspecialidadeConectasusCidadao() {
            return this.model && this.model.conectasusCidadao !== 'nao'
        },
        validations() {
            return {
                periodo: {required: true},
                inicio: {required: !!this.model.fim},
                fim: {required: !!this.model.inicio},
                diasSemana: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            jornada: this.getConectaSusRepository('ambulatorio.jornada'),
        }
    },
    data: () => ({
        others: {moment},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleConectasusCidadaoChange() {
            this.form.especialidades = []
            this.form.tipos = []
            this.form.situacoes = []
            this.model.especialidadeId = null
            this.model.tipoId = null
            this.model.situacaoId = null

            if (!this.model.ocupacaoId) return

            const request = {
                origem: 'busca',
                listar: 'especialidades',
                usuarioId: this.usuarioId,
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                inicio: this.model.inicio,
                fim: this.model.fim,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                ocupacaoId: this.model.ocupacaoId,
                especialidadeId: this.model.especialidadeId,
                tipoId: this.model.tipoId,
                conectasusCidadao: this.model.conectasusCidadao,
            }

            this.setLoading()

            this.repositories.jornada.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.especialidades = response.data.especialidades
                    this.form.tipos = response.data.tipos
                    this.form.situacoes = response.data.situacoes
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUnidadeChange(value) {
            this.form.infraestruturas = []
            this.form.ocupacoes = []
            this.form.especialidades = []
            this.form.tipos = []
            this.form.situacoes = []
            this.model.infraestruturaId = null
            this.model.ocupacaoId = null
            this.model.especialidadeId = null
            this.model.tipoId = null
            this.model.situacaoId = null

            if (value === null) return

            const request = {
                origem: 'busca',
                listar: 'infraestruturas',
                usuarioId: this.usuarioId,
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                inicio: this.model.inicio,
                fim: this.model.fim,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                ocupacaoId: this.model.ocupacaoId,
                especialidadeId: this.model.especialidadeId,
                tipoId: this.model.tipoId,
                conectasusCidadao: this.model.conectasusCidadao,
            }

            this.setLoading()

            this.repositories.jornada.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.infraestruturas = response.data.infraestruturas
                    this.form.ocupacoes = response.data.ocupacoes
                    this.form.tipos = response.data.tipos
                    this.form.situacoes = response.data.situacoes
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleInfraestruturaChange(value) {
            this.form.ocupacoes = []
            this.form.especialidades = []
            this.form.tipos = []
            this.form.situacoes = []
            this.model.ocupacaoId = null
            this.model.especialidadeId = null
            this.model.tipoId = null
            this.model.situacaoId = null

            if (value === null) return

            const request = {
                origem: 'busca',
                listar: 'ocupacoes',
                usuarioId: this.usuarioId,
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                inicio: this.model.inicio,
                fim: this.model.fim,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                ocupacaoId: this.model.ocupacaoId,
                especialidadeId: this.model.especialidadeId,
                tipoId: this.model.tipoId,
                conectasusCidadao: this.model.conectasusCidadao,
            }

            this.setLoading()

            this.repositories.jornada.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.ocupacoes = response.data.ocupacoes
                    this.form.tipos = response.data.tipos
                    this.form.situacoes = response.data.situacoes
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleOcupacaoChange(value) {
            this.form.especialidades = []
            this.form.tipos = []
            this.form.situacoes = []
            this.model.especialidadeId = null
            this.model.tipoId = null
            this.model.situacaoId = null

            if (value === null) return

            const request = {
                origem: 'busca',
                listar: 'especialidades',
                usuarioId: this.usuarioId,
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                inicio: this.model.inicio,
                fim: this.model.fim,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                ocupacaoId: this.model.ocupacaoId,
                especialidadeId: this.model.especialidadeId,
                tipoId: this.model.tipoId,
                conectasusCidadao: this.model.conectasusCidadao,
            }

            this.setLoading()

            this.repositories.jornada.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.especialidades = response.data.especialidades
                    this.form.tipos = response.data.tipos
                    this.form.situacoes = response.data.situacoes
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleEspecialidadeChange(value) {
            this.form.tipos = []
            this.form.situacoes = []
            this.model.tipoId = null
            this.model.situacaoId = null

            if (value === null) return

            const request = {
                origem: 'busca',
                listar: 'tipos',
                usuarioId: this.usuarioId,
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                inicio: this.model.inicio,
                fim: this.model.fim,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                ocupacaoId: this.model.ocupacaoId,
                especialidadeId: this.model.especialidadeId,
                tipoId: this.model.tipoId,
                conectasusCidadao: this.model.conectasusCidadao,
            }

            this.setLoading()

            this.repositories.jornada.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.tipos = response.data.tipos
                    this.form.situacoes = response.data.situacoes
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleTipoChange(value) {
            this.form.situacoes = []
            this.model.situacaoId = null

            if (value === null) return

            const request = {
                origem: 'busca',
                listar: 'situacoes',
                usuarioId: this.usuarioId,
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                inicio: this.model.inicio,
                fim: this.model.fim,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                ocupacaoId: this.model.ocupacaoId,
                especialidadeId: this.model.especialidadeId,
                tipoId: this.model.tipoId,
                conectasusCidadao: this.model.conectasusCidadao,
            }

            this.setLoading()

            this.repositories.jornada.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.situacoes = response.data.situacoes
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleSituacaoChange() {
            this.model.quantidadeConsulta = null
            this.model.quantidadeRetorno = null
        },
        search() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    const request = {
                        usuarioId: this.usuarioId,
                        periodo: {
                            start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                            end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                        },
                        inicio: this.model.inicio,
                        fim: this.model.fim,
                        diasSemana: this.model.diasSemana,
                        unidadeId: this.model.unidadeId,
                        infraestruturaId: this.model.infraestruturaId,
                        ocupacaoId: this.model.ocupacaoId,
                        especialidadeId: this.model.especialidadeId,
                        tipoId: this.model.tipoId,
                        ativa: this.model.ativa,
                        situacaoId: this.model.situacaoId,
                        quantidadeConsulta: this.model.quantidadeConsulta,
                        quantidadeRetorno: this.model.quantidadeRetorno,
                        conectasusCidadao: this.model.conectasusCidadao,
                    }

                    this.setLoading()

                    this.repositories.jornada.index(this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            this.$emit('searched', response.data.map(jornada => ({...jornada, selecionada: false})), this.isEspecialidadeConectasusCidadao)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        clean() {
            this.resetForm()
            this.$emit('cleaned', [])
        },
        setDaysOfWeek(startDate, endDate) {
            this.model.diasSemana = []
            this.form.diasSemana.forEach(diaSemana => diaSemana.disabled = true)

            startDate = this.others.moment(startDate)
            endDate = this.others.moment(endDate)

            while (startDate.isSameOrBefore(endDate)) {
                this.form.diasSemana.find(diaSemana => diaSemana.id == startDate.day() + 1).disabled = false

                if (this.model.diasSemana.indexOf(startDate.day() + 1) === -1) {
                    this.model.diasSemana.push(startDate.day() + 1)
                }

                startDate.add(1, 'days')
            }
        },
        resetForm() {
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.ocupacoes = []
            this.form.especialidades = []
            this.form.tipos = []
            this.form.situacoes = []
            this.form.diasSemana.forEach(diaSemana => diaSemana.disabled = true)
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.lotacaoId = null
            this.model.especialidadeId = null
            this.model.periodo = {
                start: null,
                end: null,
            }
            this.model.inicio = null
            this.model.fim = null
            this.model.diasSemana = null
            this.model.quantidadeConsulta = null
            this.model.tempoConsulta = null
            this.model.quantidadeRetorno = null
            this.model.tempoRetorno = null
            this.model.conectasusCidadao = null

            this.$refs.RkmForm.resetValidator()
        },
    },
    mixins: [error, repository, stringCase],
    props: {
        form: {type: Object, required: true},
        model: {type: Object, required: true},
        usuarioId: {type: [Number, String], required: true},
    },
    watch: {
        'model.periodo': {
            deep: true,
            handler(value) {
                this.form.unidades = []
                this.form.infraestruturas = []
                this.form.ocupacoes = []
                this.form.especialidades = []
                this.form.tipos = []
                this.form.situacoes = []
                this.model.unidadeId = null
                this.model.infraestruturaId = null
                this.model.ocupacaoId = null
                this.model.especialidadeId = null
                this.model.tipoId = null
                this.model.situacaoId = null

                if (value.start === null || value.end === null) return

                const request = {
                    origem: 'busca',
                    listar: 'unidades',
                    usuarioId: this.usuarioId,
                    periodo: {
                        start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                        end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                    },
                    inicio: this.model.inicio,
                    fim: this.model.fim,
                    unidadeId: this.model.unidadeId,
                    infraestruturaId: this.model.infraestruturaId,
                    ocupacaoId: this.model.ocupacaoId,
                    especialidadeId: this.model.especialidadeId,
                    tipoId: this.model.tipoId,
                    conectasusCidadao: this.model.conectasusCidadao,
                }

                this.setLoading()

                this.repositories.jornada.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.unidades = response.data.unidades
                        this.form.infraestruturas = response.data.infraestruturas
                        this.form.ocupacoes = response.data.ocupacoes
                        this.form.tipos = response.data.tipos
                        this.form.situacoes = response.data.situacoes
                        this.setDaysOfWeek(value.start, value.end)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            },
        },
        'model.ativa'() {
            this.model.situacaoId = null
        },
    },
}
</script>

<style scoped>
.dias-semana >>> .btn-group {
    width: 100%;
}

.especialidade-col {
    position: relative;
}

.infor-especialidade {
    color: #acacac;
    height: 15px;
    width: 15px !important;
    border-radius: 31px;
    padding: 3px;
    border: 1px solid #c2c2c2;
    position: absolute;
    top: 5px;
    left: 115px;
}
</style>
